import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './page/Login/Login';
import CardsExam from './page/CardsExam/CardsExam';
import Routers from './Routers.js';
import * as serviceWorker from './serviceWorker';

ReactDOM.render( <Routers /> , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();